import { useAppSelector } from "@/hooks";
import { classNameGenerator } from "@/utils";
import styles from "./BenefitsCards.module.scss"
import Typography from "@/foundation/Typography/V2";
import { SVGSprite } from "@/components/Atoms";

const BenefitsCards = () => {
    const { data } = useAppSelector((state) => state.bootCamp);
    const cls = classNameGenerator(styles);

    if (!data?.benefitsCards) {
        return <></>
    }

    const { title, suitedFor, notSuitedFor } = data?.benefitsCards
    const { subTitle, points } = notSuitedFor

    return (
        <section className={cls("benefitsCards")}>
            <div className={cls("container")}>
                <div className={cls("cardWrapper")}>
                    <div className={cls("suited")}>
                        <Typography variant="heading6" className={cls("heading")}>
                            {title}
                        </Typography>
                        <div className={cls("points")}>
                            {
                                suitedFor?.map((_val) => {
                                    return <div className={cls("suitedFor")}>
                                        <div className={cls("contentIcon")}>
                                            <SVGSprite
                                                icon="icon-list-check"
                                                className={cls("icon")}
                                            />
                                        </div>
                                        <Typography variant="paragraph1" className={cls("point")}>
                                            {_val}
                                        </Typography>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                    <div className={cls("notSuited")}>
                        <div className={cls("heading")}>
                            <SVGSprite
                                icon="icon-slash"
                                className={cls("icon")}
                            />
                            <Typography variant="paragraph1" className={cls("subHeading")}>
                                {subTitle}
                            </Typography>
                        </div>
                        <div className={cls("points")}>
                            {
                                points?.map((_val) => {
                                    return <div className={cls("suitedFor")}>
                                        <Typography variant="paragraph1" className={cls("point")}>
                                            &#8594; {_val}
                                        </Typography>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BenefitsCards;